export const HEALTHFIRST_HOME_INFO = {
  title: 'Experience <br> Greater Savings On',
  subTitle: 'Save up to 70% on your family’s total health expenses and protect against critical illnesses with a HealthFirst plan',
  wordArray: [
    'Hospitalisation',
    'Consultations'
  ],
  plans: [
    { id: 1, title: 'Online OPD Consultation', desc: 'Sed ut perspic iatis unde', img:'hf-calendar'},
    { id: 2, title: 'Surgery Care', desc: 'Sed ut perspic iatis unde', img: 'hf-medical'},
    { id: 3, title: 'Online Pharmacy', desc: 'Sed ut perspic iatis unde', img:'hf-medicine'},
    { id: 4, title: 'Lab Test', desc: 'Sed ut perspic iatis unde', img: 'hf-laboratory'},
    { id: 5, title: 'Surgery', desc: 'Sed ut perspic iatis unde', img: 'hf-surgery'},
  ],
  plansMob: [],
  planBenefits: [
    { id: 1, title: '70% Savings', desc: 'on medical expenses' },
    { id: 2, title: '₹ 1,000 / Day', desc: 'guaranteed on hospitalisation' },
    { id: 3, title: '₹ 4,000 instant', desc: 'credit in your medibuddy wallet' },
  ],
  benefits: [
    { id: 1, title: 'Low rates, Great discounts', desc: 'Save 15% or more on your daily health needs with an affordable HealthFirst plan', imgName: 'hf-discount' },
    { id: 2, title: 'Unlimited doctors support', desc: 'Guided virtual care by specialists to tackle lifestyle risks, anywhere in India', imgName: 'hf-doctor-support' },
    { id: 3, title: 'Customisable plans', desc: 'Personalize your plan with extra coverages for that extra layer of protection', imgName: 'hf-customisable-plan' },
    { id: 4, title: 'Great for the family', desc: 'Cover entire family at a lower cost and enjoy 80D tax benefits while you\'re at it', imgName: 'hf-family' },
    { id: 5, title: 'End-to-end surgery care', desc: 'We’ll schedule surgery, manage your commute, file your paperwork & more!', imgName: 'hf-surgery-care' },
  ],
  whyTitle: 'why you should choose',
  whySubTitle: 'Ketto HealthFirst',
  whySmallDesc: 'Affordable plans, unique benefits ignored by traditional health covers, and exceptional savings for the entire family—that\'s why!',
  calculatorInfo: {
    title: 'calculate your family’s annual',
    subTitle: 'health savings with Ketto HealthFirst',
    desc: 'See how much you\'ll save with HealthFirst after our risk meter evaluates your family\'s unique needs'
  },
  calculator : {
    title: 'reduce your medical expenses upto ',
    subTitle: 'WITH KETTO HEALTH FIRST',
    desc: 'Tell us a little about your family and we’ll tell you how much you’ll save with your personalised plan',
    amount: '₹ 6,500'
  },
  planDetails: {
    header: {
      subscribeText: 'subscribe to Ketto Health First for',
      title: 'Ketto HealthFirst',
      title2: '',
      subTitle: 'pocket-friendly plans',
      desc: 'Choose the plan that best meets your family’s unique needs',
      img: null
    },
    plans: [
      {
        "title": "<div><strong>Consultations with top doctor</strong></div>",
        "offers": [
          {
            "title": "Physical OPD consults",
            "plan1": 2,
            "plan2": 4
          },
          {
            "title": "24*7 unlimited teleconsult",
            "plan1": "yes",
            "plan2": "yes"
          },
          {
            "title": "Consultations with top doctor",
            "plan1": "yes",
            "plan2": "yes"
          }
        ]
      },
      {
        "title": "<div><strong>70% off lab tests at network centers</strong></div>",
        "offers": [
          {
            "title": "Instant cash Medibuddy wallet",
            "plan1": "+ ₹ 1,000",
            "plan2": "+ ₹ 2,000"
          },
          {
            "title": "Free Home Sample Collection",
            "plan1": "yes",
            "plan2": "yes"
          }
        ]
      },
      {
        "title": "<div><strong>Lowest prices on your medication</strong></div>",
        "offers": [
          {
            "title": "Instant cash Medibuddy wallet",
            "plan1": "+ ₹ 500",
            "plan2": "+ ₹ 2,000"
          },
          {
            "title": "Up to 15% off on online orders",
            "plan1": "yes",
            "plan2": "yes"
          }
        ]
      },
      {
        "title": "<div><strong>Daily hospital cash benefits</strong></div>",
        "offers": [
          {
            "title": "Guaranteed ₹ 1,000/day for ICU",
            "plan1": "no",
            "plan2": "yes"
          },
          {
            "title": "100% hospitals covered across India",
            "plan1": "no",
            "plan2": "yes"
          }
        ]
      },
      {
        "title": "<div><strong>Surgery care benefits of ₹ 1,000</strong></div>",
        "offers": [
          {
            "title": "Hassle-free admission & discharge",
            "plan1": "no",
            "plan2": "yes"
          },
          {
            "title": "Financial Counselling & EMI Support",
            "plan1": "no",
            "plan2": "yes"
          },
          {
            "title": "Post Surgery Care",
            "plan1": "no",
            "plan2": "yes"
          }
        ]
      },
      {
        "title": "<div><strong>Additional Cash Bonus</strong></div>",
        "offers": [
          {
            "title": "Additional Cash Bonus",
            "plan1": "+ ₹ 1,600",
            "plan2": "+ ₹ 3,200"
          }
        ]
      },
      {
        "title": "<div><strong>Critical Illness Cover</strong></div>",
        "offers": [
          {
            "title": "Obtain a critical illness add-on starting at just ₹ 1,000.",
            "plan1": "OPTIONAL",
            "plan2": "OPTIONAL"
          }
        ]
      }
    ]
  },
  commentsSection: {
    header: {
      title: 'see why people like you',
      subTitle: 'love Ketto\'s HealthFirst',
      desc: 'Don’t just take our word for it, hear what others have to say!'
    },
    comments: []
  },
  contactSection: {
    content: {
      title: 'we\'re',
      subTitle: 'here to help you!',
      desc: 'Have questions? Let’s connect – we’d love to hear from you'
    },
    contactLinks: {
      email: 'info@ketto.org',
      phone: '+919930088522'
    }
  },
  recommended_plan: ''
}